import { ENDPOINTS } from "../../js/api/_config";
import Axios from "axios";

export const getHomePageRelatedData = async () => {
    return await Axios({
        method: 'GET',
        url: 'https://trinitysandboxcms.azurewebsites.net/restapi/ucommerce/latest/courses',
        headers: {
            'Accept': 'application/json',            
        }        
    }).then(e => {
        return e;
    }).catch(e => {
        return e;
    })
};    